document.addEventListener("alpine:init", () => {
  console.log("STORE INIT");
  function getStatesByCountry(country) {
    return window.customization?.config.stateData.filter(
      (s) => s.country.toLowerCase() == country.toLowerCase()
    );
  }

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  Alpine.store("customStore", {
    data: {
      countries: [
        { label: "United States", value: "United States", countryCode: "US" },
        { label: "Canada", value: "Canada", countryCode: "CA" },
      ],
      states: getStatesByCountry(
        window.customization?.data?.customer?.default_address.country || "United States"
      ),
    },
    firstName: window.customization?.data?.customer?.first_name || "",
    lastName: window.customization?.data?.customer?.last_name || "",
    termsAgreed: false,
    note: "",
    address: {
      country:
        window.customization?.data?.customer?.default_address.country || "United States",
      address1:
        window.customization?.data?.customer?.default_address.address1 || "",
      city: window.customization?.data?.customer?.default_address.city || "",
      state:
        window.customization?.data?.customer?.default_address.province || "",
      zip: window.customization?.data?.customer?.default_address.zip || "",
    },
    formInvalid: false,
    mutating: false,
    errors: {
      firstName: "",
      address1: "",
      lastName: "",
      country: "",
      city: "",
      state: "",
      zip: "",
      termsAgreed: "",
    },
    apiError: "",

    onCountryChange() {
      this.data.states = getStatesByCountry(this.address.country);
      this.address.city = "";
      this.address.address1 = "";
      this.address.zip = "";
      this.address.state = "";
    },
    validateAddress() {
      this.formIsvalid = true;
      this.errors.firstName = "";
      this.errors.lastName = "";
      this.errors.address1 = "";
      this.errors.country = "";
      this.errors.state = "";
      this.errors.city = "";
      this.errors.zip = "";
      this.errors.termsAgreed = "";
      if (!this.firstName.trim()) {
        this.errors.firstName = "Please enter first name.";
        this.formIsvalid = false;
      }
      if (!this.lastName.trim()) {
        this.errors.lastName = "Please enter last name.";
        this.formIsvalid = false;
      }
      if (!this.termsAgreed) {
        this.errors.termsAgreed = 'You must agree with the terms and conditions of sales to check out';
        this.formIsvalid = false;
      }
      if (!this.address.address1.trim()) {
        this.errors.address1 = "Please enter address.";
        this.formIsvalid = false;
      }
      if (!this.address.country.trim()) {
        this.errors.country = "Please select country.";
        this.formIsvalid = false;
      }
      if (!this.address.state.trim()) {
        this.errors.state = "Please select state.";
        this.formIsvalid = false;
      }
      if (!this.address.city.trim()) {
        this.errors.city = "Please enter city.";
        this.formIsvalid = false;
      }
      if (!this.address.zip.trim()) {
        this.errors.zip = "Please enter Zip code.";
        this.formIsvalid = false;
      } else if (
        !/^(\d{5}(-\d{4})?|[A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d)$/.test(
          this.address.zip.trim()
        )
      ) {
        this.errors.zip = "Invalid Zip code.";
        this.formIsvalid = false;
      }

      if (!this.formIsvalid) {
        console.log("INVALID ADDRESS");
      }
    },
    async processOrder() {
      this.validateAddress();
      if (!this.formIsvalid) return;

      const cart = await fetch(window.Shopify.routes.root + "cart.js").then(
        (r) => r.json()
      );
      const payload = {
        email: window.customization?.data?.customer?.email || undefined,
        shippingAddress: {
          firstName: this.firstName?.trim() || undefined,
          lastName: this.lastName?.trim(),
          address: this.address.address1?.trim(),
          city: this.address.city?.trim(),
          state: this.address.state?.trim(),
          country: this.address.country?.trim(),
          zip: this.address.zip?.trim().replace(/\s/g, ""),
          isDefault: false,
        },
        products: cart.items.map((item) => ({
          quantity: item.quantity,
          productId: "" + item.product_id,
          productVariantId: "" + item.variant_id,
          discountedPrice: item.discounted_price / 100 ,
          properties: item.properties || undefined,
        })),
      };
      this.apiError = "";
      this.mutating = true;

      fetch(
        "https://avalara-taxes-gpen-app.evoortsolutions.com/api/draft-order",
        {
          method: "POST",
          body: JSON.stringify(payload),
          headers: {
            "X-Shop-Name": window.customization.data.shop.permanent_domain,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      )
        .then((res) => res.json())
        .then((data) => {
          if (data.success) {
            this.mutating = false;
            const preparedUrl = data.data.invoice_url;
            const url = new URL(preparedUrl);
            window.location.href = url.pathname;
          } else {
            if (data.errors?.length > 0) {
              this.apiError = data.errors?.[0]?.message;
            } else if (data.errors?.shipping_address) {
              let invalidAddressMessage = "";
              for (let shopify_error of data.errors.shipping_address.zip ||
                []) {
                invalidAddressMessage += shopify_error.message;
              }
              for (let shopify_error of data.errors.shipping_address
                .province_code || []) {
                invalidAddressMessage += shopify_error.message;
              }
              this.apiError = invalidAddressMessage;
            } else if (data.message) {
              this.apiError = data.message;
            }
            this.mutating = false;
          }
        })
        .catch((err) => {
          this.apiError = err.message || "Something went wrong.";
          this.mutating = false;
        });
    },
  });
});
